import { ComparisonTableProps } from "@bluebottlecoffee/design-system/components";
import { ComparisonTable as Schema } from "../sanity-schema";
import { toImageProps } from "./image";

export function toComparisonTableProps(
  data: Schema,
  lang: string,
): ComparisonTableProps {
  return {
    title: data.title[lang],
    features: data.features.map((feature) => ({
      key: feature.key,
      label: feature.label[lang],
    })),
    plans: data.plans.map((plan) => ({
      name: plan.name[lang],
      ...(plan.tagline && { tagline: plan.tagline[lang] }),
      ...(plan.isFeatured && { isFeatured: plan.isFeatured }),
      ...(plan.featuredLabel && { featuredLabel: plan.featuredLabel[lang] }),
      ...(plan.isDeemphasized && { isDeemphasized: plan.isDeemphasized }),
      includedFeatureKeys: plan.includedFeatureKeys,
      ...(plan.giftImage && {
        giftImage: toImageProps(plan.giftImage, lang),
      }),
      ...(plan.giftLabel && { giftLabel: plan.giftLabel[lang] }),
      ...(plan.giftDescription && {
        giftDescription: plan.giftDescription[lang],
      }),
    })),
  };
}
